<template>
	<div>
		<div class="wrapper">
			<!-- 서브 헤더 --------- start -->
			<v-layout wrap class="mb-2" align-center>
				<v-icon color="#9D9DB7">
					mdi-circle-small
				</v-icon>
				<span class="sub_header">마케팅DB 고객 현황</span>
			</v-layout>
			<!-- 서브 헤더 ----------- end -->

			<v-flex class="py-0 px-5 header_search_box">
				<v-layout align-center class="header_search_1">
					<v-flex xs4 class="d-flex">
						<div class="customer-circumstance-text ml-2 mt-1">
							프로젝트
						</div>
						<v-flex class="maketingDB_search_select_type ml-2 ">
							<selectBox :sel="projectCategory" :class="'searchSel'" @change="projectChange"></selectBox>
						</v-flex>
					</v-flex>
					<v-flex xs4 class="d-flex">
						<div class="customer-circumstance-text ml-2 mt-1">
							DB명
						</div>
						<v-flex class="maketingDB_search_select_type ml-2 ">
							<selectBox :sel="marketingDbCategory" :class="'searchSel'" @change="marketingDbChange"></selectBox>
						</v-flex>
					</v-flex>
					<v-flex xs4 class="d-flex">
						<div class="customer-circumstance-text ml-2 mt-1">
							캠페인
						</div>
						<v-flex class="maketingDB_search_select_type ml-2 ">
							<selectBox :sel="campaignCategory" :class="'searchSel'" @change="campaignChange"></selectBox>
						</v-flex>
					</v-flex>
				</v-layout>

				<v-layout class="header_search_1" align-center>
					<v-flex xs4 class="d-flex">
						<div class="customer-circumstance-text_1 ml-2 mt-1">
							생성일
						</div>
						<v-flex :class="'maketingDB_search_date_1 ml-2'">
							<DatepickerDialog :picker="createStartPicker"></DatepickerDialog>
						</v-flex>
						<span class="etc_date mx-2"> ~ </span>
						<v-flex :class="'maketingdb_search_date_2'">
							<DatepickerDialog :picker="createEndPicker" :allowed_dates="termCustomer"></DatepickerDialog>
						</v-flex>
						<v-btn
							class="search_range_btn_1"
							color="#ff9419"
							@click="
								() => {
									first = false
									searchType = 'range'
									clickSearch('create')
								}
							"
							><v-icon>mdi-magnify</v-icon>기간조회</v-btn
						>
					</v-flex>
					<v-flex xs4 class="d-flex">
						<div class="customer-circumstance-text_1 ml-2 mt-1">
							처리일
						</div>
						<v-flex :class="'maketingDB_search_date_1 ml-2'">
							<DatepickerDialog :picker="processStartPicker"></DatepickerDialog>
						</v-flex>
						<span class="etc_date mx-2"> ~ </span>
						<v-flex :class="'maketingdb_search_date_2'">
							<DatepickerDialog :picker="processEndPicker" :allowed_dates="termCustomer"></DatepickerDialog>
						</v-flex>
						<v-btn
							class="search_range_btn_1"
							color="#ff9419"
							@click="
								() => {
									first = false
									searchType = 'range'
									clickSearch('process')
								}
							"
							><v-icon>mdi-magnify</v-icon>기간조회</v-btn
						>
					</v-flex>

					<!-- 영업팀 선택 --------- start -->
					<!-- <div class="customer-circumstance-text_2 ml-2 mt-1">
						상태
					</div>
					<v-flex class="search_select_1 ml-2 ">
						<selectBox :sel="statusSel" :class="'searchSel_thin'"></selectBox>
					</v-flex>
					<v-flex class="search_select_1 ml-2 ">
						<selectBox :sel="searchStatusSel" :class="'searchSel_thin'"></selectBox>
					</v-flex>
					<v-flex class="search_box_1">
						<txtField
							class="maketingDB_search_box_type"
							v-model="search.value"
							:txtField="search"
							@keyup.enter="clickSearch('search')"
							ref="search_input"
						></txtField>
					</v-flex>

					<v-btn class="search_btn_1" color="#ff9419" @click="clickSearch('search')"><v-icon>mdi-magnify</v-icon>조회</v-btn>
					<v-btn class="search_btn_1" color="#ff9419" @click="search_reset">초기화</v-btn> -->
				</v-layout>
				<v-layout class="header_search_1 ma-0" align-center>
					<v-flex xs4 class="d-flex">
						<div class="customer-circumstance-text_2 ml-2 mt-1">
							상태
						</div>
						<v-flex class="search_select_1 ml-2 ">
							<selectBox :sel="statusSel" :class="'searchSel_thin'"></selectBox>
						</v-flex>
					</v-flex>
					<v-flex xs4 class="d-flex">
						<div class="customer-circumstance-text_2 ml-2 mt-1">
							결과
						</div>
						<v-flex class="search_select_1 ml-2 ">
							<selectBox :sel="searchResultSel" :class="'searchSel_thin'"></selectBox>
						</v-flex>
					</v-flex>
					<v-flex xs4 class="d-flex">
						<v-flex class="search_select_1 ml-2 ">
							<selectBox :sel="searchStatusSel" :class="'searchSel_thin'"></selectBox>
						</v-flex>
						<!-- 영업팀 선택 --------- end -->
						<!-- 이름 검색 start  -->
						<v-layout>
							<txtField
								class="maketingDB_search_box_type"
								v-model="search.value"
								:txtField="search"
								@keyup.enter="clickSearch('search')"
								ref="search_input"
							></txtField>
							<v-btn class="search_btn_1" color="#ff9419" @click="clickSearch('search')"><v-icon>mdi-magnify</v-icon>조회</v-btn>
							<v-btn class="search_btn_1" color="#ff9419" @click="search_reset">초기화</v-btn>
						</v-layout>
					</v-flex>

					<!-- 이름 검색 end  -->
				</v-layout>
			</v-flex>

			<v-layout class="search_sub_wrap">
				<div class="sub_text_title " v-for="(searchs, index) of searchTag" :key="index">
					<div class="ml-2" v-if="searchs.text || searchs.text !== ''">
						<div class="customer-circumstance-sub-text">
							{{ searchs.text }}
						</div>
						<v-icon class="sub-text_chip_close" @click="deleteTag(index)">mdi-close</v-icon>
					</div>
				</div>
			</v-layout>

			<!-- --- 데이터 테이블 -------- start -->
			<v-layout wrap>
				<!-- 테이블 -->
				<v-flex xs12>
					<datatable
						:searchAdd="searchAdd"
						:search="search.value"
						:datatable="table.datatable"
						:noDataText="'검색어를 입력하시거나 선택하세요.'"
						class="tbl-type01 table_td_smallPadding"
						excelUseYn="true"
						excelType="marketing_DB_customer"
						@pagination="pagination"
						:getExcelData="getExcelData"
						excelTextYn="true"
						excelRoute="marketingDBCustomerCircumstance"
					>
					</datatable>
				</v-flex>
			</v-layout>
			<!-- --- 데이터 테이블 -------- end -->
			<sweetAlert :dialog="alert_dialog"></sweetAlert>
			<sweetAlert :dialog="success_dialog"></sweetAlert>
		</div>
	</div>
</template>

<script>
import { DatepickerDialog, datatable, selectBox, txtField, sweetAlert } from '@/components/index.js'
export default {
	name: 'marketingDBCustomerCircumstance',
	components: {
		datatable,
		selectBox,
		txtField,
		sweetAlert,
		DatepickerDialog,
	},

	data() {
		return {
			data_detail: false,
			gl: [],
			hq: [],
			team: [],
			clicked_data: {},
			tableData: [],
			businessId: '',
			blocked_count: '',
			approval_count: '',
			createStartPicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},
			createEndPicker: {
				// datePicker
				date: this.$moment()
					.add(7, 'days')
					.format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},
			processStartPicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},
			processEndPicker: {
				// datePicker
				date: this.$moment()
					.add(7, 'days')
					.format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},
			projectCategory: {
				// 프로젝트 셀렉트 박스
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
				placeholder: '프로젝트 선택',
			},

			marketingDbCategory: {
				// 마케팅DB 셀렉트 박스
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
				placeholder: 'DB 선택',
			},

			campaignCategory: {
				// 캠페인 셀렉트 박스
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
				placeholder: '캠페인 선택',
			},
			// 기본 테이블
			table: {
				datatable: {
					headers: [
						{ text: 'No.', value: 'index', width: '4%', sortable: false },
						{ text: '고객명', value: 'cs_name', width: '5%', sortable: false },
						{ text: '휴대전화번호', value: 'cs_phone', width: 'auto', sortable: false },
						{ text: '관리ID', value: 'cs_adm_id', width: 'auto', sortable: false },
						{ text: '캠페인ID', value: 'cs_cn_id', width: 'auto', sortable: false },
						{ text: '프로젝트명', value: 'pj_name', width: 'auto', sortable: false },
						{ text: 'DB명', value: 'mdb_title', width: 'auto', sortable: false },
						{ text: '캠페인명', value: 'cpn_title', width: 'auto', sortable: false },
						{ text: '생성일', value: 'mdb_created', width: 'auto', sortable: false },
						{ text: '처리일', value: 'cs_processed', width: 'auto', sortable: false },
						{ text: '상태', value: 'cs_status_text', width: '5%', sortable: false },
						{ text: '결과', value: 'cs_result', width: '6%', sortable: false },
						{ text: '담당자', value: 'cn_info', width: 'auto', sortable: false },
					],
					items: [],
					hidedefaultfooter: false,
					noweditting: '',
					onlyAgree: false,
					selected_user: [],
					//페이지네이션
					total: 0,
					itemPerPage: 10,
					page: 1,
					pageCount: 0,
					pagination: {
						start: 0,
						page: 1,
						itemsPerPage: 10,
					},
				},
				filter: [],
				json_fields: {},
			},

			// 날짜/검색 데이터
			searchsel: {
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
			},
			// 상태 필터
			statusSel: {
				value: 'all',
				errorMessage: '',
				hideDetail: true,
				items: [
					{ value: 'all', text: '전체' },
					{ value: 'processed', text: '처리' },
					{ value: 'unprocessed', text: '미처리' },
				],
				outlined: true,
				itemText: 'text',
				placeholder: '상태',
			},
			// 검색 상태 필터
			searchStatusSel: {
				value: 'name',
				errorMessage: '',
				hideDetail: true,
				items: [
					{ value: 'manageId', text: '관리ID' },
					{ value: 'customerId', text: '캠페인ID' },
					{ value: 'phone', text: '휴대전화번호' },
					{ value: 'name', text: '고객명' },
					{ value: 'csnName', text: '담당자명' },
				],
				outlined: true,
				itemText: 'text',
				placeholder: '분류',
			},

			searchResultSel: {
				value: 'all',
				errorMessage: '',
				hideDetail: true,
				items: [
					{ value: 'all', text: '전체' },
					{ value: 'success', text: '통화성공' },
					{ value: 'reserve', text: '통화예약' },
					{ value: 'absence', text: '보류' },
					{ value: 'reject', text: '거부' },
					{ value: 'meetingReserve', text: '방문예약' },
					{ value: 'meetingNoShow', text: '미방문' },
					{ value: 'meetingDone', text: '상담완료' },
					{ value: 'contractExpact', text: '계약가망' },
					{ value: 'contractTemp', text: '가계약' },
					{ value: 'contractConfirm', text: '계약확인' },
				],
				outlined: true,
				itemText: 'text',
				placeholder: '분류',
			},
			// 영업팀 데이터
			bigTeamSel: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: [{ text: '', value: {} }],
				outlined: true,
				itemText: 'text',
			},
			mediumTeamSel: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				itemText: 'text',
			},
			smallTeamSel: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				itemText: 'text',
			},
			// 권한 데이터
			authoritySel: {
				value: 'all',
				errorMessage: '',
				hideDetail: true,
				items: [
					{ text: '전체', value: 'all' },
					{ text: '총괄', value: 'GeneralManager' },
					{ text: '본부', value: 'HeadquarterManager' },
					{ text: '팀장', value: 'TeamLeader' },
					{ text: '상담사', value: 'Counselor' },
				],
				outlined: true,
				itemText: 'text',
			},

			// search_project_input: '',
			// search_project: '',
			search: {
				value: '',
				placeholder: '검색어를 입력해주세요.',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
			},
			// 마케터 자세히보기 다이어로그
			marketerManage_dialog: {
				dialog: false,
			},
			// 마케터 그룹 다이어로그
			marketerGroup_dialog: {
				dialog: false,
			},
			//경고 모달
			alert_dialog: {
				title: '',
				modalIcon: 'error',
				content: '',
				buttonType: 'oneBtn',
				open: false,
				cancelBtnText: '닫기',
				saveBtnText: '확인',
			},
			//성공 모달
			success_dialog: {
				title: '',
				modalIcon: 'success',
				content: '',
				buttonType: 'oneBtn',
				open: false,
				cancelBtnText: '닫기',
				saveBtnText: '확인',
				closeFunction: '',
			},
			addBtn: {
				// 추가 버튼
				dark: true,
			},

			filter: [],

			searchPhone: '',
			searchName: '',
			searchBtn: {
				class: '',
				dark: true,
				color: this.$store.state.PointColor2,
				height: 40,
			},
			excelArr: [],

			searchType: '', // range - 기간 검색, text - 이름/전화번호 검색
			searchTag: [],
		}
	},
	async created() {
		await this.bizTitle()
	},
	props: {
		nowTabs: Number,
		tabIdx: Number,
	},
	// watch: {
	// 	edit_dialog: {
	// 		deep: true,
	// 		handler() {
	// 			// 값 다시 불러오기
	// 		},
	// 	},
	// 	nowTabs: {
	// 		deep: true,
	// 		async handler() {
	// 			// if (this.nowTabs === this.tabIdx) {
	// 			// }
	// 		},
	// 	},
	// },
	methods: {
		async getSingleCustomerDetail(range) {
			let variable = {}

			if (range) {
				variable['start'] = range.start
				variable['limit'] = range.limit
			} else {
				variable['start'] = (this.table.datatable.pagination.page - 1) * this.table.datatable.pagination.itemsPerPage
				variable['limit'] = this.table.datatable.pagination.itemsPerPage
			}
			for (let i = 0; i < this.searchTag.length; i++) {
				if (this.searchTag[i].key === 'mdb_created') {
					variable['createStart'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 00:00:00'))
					variable['createEnd'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 23:59:59'))
				} else if (this.searchTag[i].key === 'cs_processed') {
					variable['processStart'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 00:00:00'))
					variable['processEnd'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 23:59:59'))
				} else if (this.searchTag[i].key === 'resultStatus') {
					variable['resultStatus'] = this.searchTag[i].value.resultStatus
					variable['resultGrade'] = this.searchTag[i].value.resultGrade
				} else {
					variable[`${this.searchTag[i].key}`] = this.searchTag[i].value
				}
			}
			this.$store.state.loading = true
			await this.$store.dispatch('marketingDBcustomerSingle', variable).then(res => {
				this.$store.state.loading = false
				const response = res.data.singleCustomerDetail.response
				this.$refs.search_input.$children[0].$refs.input.blur()
				if (response.code === 1000) {
					// 성공 시에만 데이터 세팅
					let new_arr = []
					// 데이터 형식 맞추기
					for (let index = 0; index < response.data.length; index++) {
						let single_data = { ...response.data[index] }
						single_data['index'] = variable.start + index + 1
						single_data['cs_phone_original'] = single_data['cs_phone']
						single_data['cs_phone'] = single_data['cs_phone'] ? this.maskingPhoneNumber(single_data['cs_phone']) : ''
						single_data['cs_name_original'] = single_data['cs_name']
						single_data['cs_name'] = single_data['cs_name'] ? this.maskingName(single_data['cs_name']) : ''
						single_data['mdb_created'] = single_data['mdb_created']
							? this.$moment(single_data['mdb_created']).format('YYYY-MM-DD HH:mm')
							: '' // 생성일
						single_data['cs_processed'] = single_data['cs_processed']
							? this.$moment(single_data['cs_processed']).format('YYYY-MM-DD HH:mm')
							: null // 추출일
						single_data['cs_status_text'] = this.convertStatus(single_data['cs_status'], single_data['cs_like']).status // 상태
						single_data['cs_status_text_original'] = single_data['cs_status_text'] === '처리' ? 'processed' : 'unprocessed'
						single_data['cs_result'] = this.convertStatus(single_data['cs_status'], single_data['cs_like']).like // 결과
						single_data['cs_result_original'] = { resultStatus: single_data['cs_status'], resultGrade: single_data['cs_like'] } // 결과
						single_data['cn_info'] = single_data['cn_info'] ? single_data['cn_info'] + ' / ' + single_data['cn_name'] : '-'
						new_arr.push(single_data)
						// 빈값인 것들 '-' 로 처리
						for (const [key, value] of Object.entries(single_data)) {
							if (!value) single_data[key] = '-'
						}
					}
					this.table.datatable.items = new_arr
					this.table.datatable.total = response.total
				} else {
					this.table.datatable.items = []
					this.table.datatable.total = 0
				}
			})
		},

		async deleteTag(index) {
			this.searchTag.splice(index, 1)
			if (this.searchTag.findIndex(el => el.key === 'name' || el.key === 'phone') > -1) {
				this.type = 'single_tag'
				this.table.datatable.page = 1
				this.table.datatable.pagination.page = 1
				this.getSingleCustomerDetail()
			} else {
				await this.clickSearch('tag')
			}
		},

		async searchAdd(value, text, key) {
			if (!text || text === '-' || key === '-' || !key) {
				return false
			}
			let onIndex = this.searchTag.findIndex(el => el.key === value)
			if (onIndex > -1) {
				this.searchTag[onIndex].value = key
				this.searchTag[onIndex].text = text
			} else {
				this.searchTag.push({
					key: value,
					text: text,
					value: key,
				})
			}

			if (this.searchTag.findIndex(el => el.key === 'name' || el.key === 'phone') > -1) {
				this.type = 'single_tag'
				this.table.datatable.page = 1
				this.table.datatable.pagination.page = 1
				this.getSingleCustomerDetail()
			} else {
				await this.clickSearch('tag')
			}
		},
		async clickSearch(type) {
			if (type !== 'tag') {
				this.searchTag = []
			}
			this.type = type
			this.table.datatable.page = 1
			this.table.datatable.pagination.page = 1
			await this.getMarketingDBcustomerList()
		},

		/**초기화 버튼
		@author 노의진
		*/
		async search_reset() {
			this.projectCategory.value = null
			this.marketingDbCategory.value = null
			this.campaignCategory.value = null
			this.statusSel.value = 'all'
			this.searchResultSel.value = 'all'
			this.searchStatusSel.value = 'name'
			this.createStartPicker.date = this.$moment().format('YYYY-MM-DD')
			this.createEndPicker.date = this.$moment()
				.add(7, 'days')
				.format('YYYY-MM-DD')
			this.processStartPicker.date = this.$moment().format('YYYY-MM-DD')
			this.processEndPicker.date = this.$moment()
				.add(7, 'days')
				.format('YYYY-MM-DD')
			this.search.value = ''
			this.table.datatable.items = []
			this.type = ''
			this.searchTag = []
		},
		async bizTitle() {
			this.$store.state.loading = true
			// 비즈니스 카테고리 리스트 불러오기
			await this.$store.dispatch('bizTitle').then(async res => {
				if (res.data.bizTitle.businesses.length > 0) {
					this.projectCategory.items = res.data.bizTitle.businesses
					// this.projectCategory.value = res.data.bizTitle.businesses[0]

					this.$store.state.loading = false
				} else {
					this.projectCategory.items = []
					this.projectCategory.value = null
				}
			})

			this.$store.state.loading = false
		},

		/**** 마케팅DB 리스트 호출해서 마케팅DB 셀렉트박스 데이터 세팅
 @author 전현균
 */

		async marketingDbsTitle() {
			const variable = {}

			if (this.projectCategory.value && this.projectCategory.value.id !== 'all') {
				variable['businessId'] = String(this.projectCategory.value.id)

				// 마케팅DB 리스트 불러오기
				await this.$store.dispatch('marketingDbsTitle', variable).then(async res => {
					if (res.data.marketingDbs.length > 0) {
						res.data.marketingDbs.unshift({
							id: 'all',
							title: '전체',
						})

						this.marketingDbCategory.items = res.data.marketingDbs
						this.marketingDbCategory.value = res.data.marketingDbs[0]
					} else {
						this.marketingDbCategory.items = []
						this.marketingDbCategory.value = null
					}
				})
			}

			// 마케팅DB 리스트 불러오기
			await this.$store.dispatch('marketingDbsTitle', variable).then(async res => {
				if (res.data.marketingDbs.length > 0) {
					res.data.marketingDbs.unshift({
						id: 'all',
						title: '전체',
					})

					this.marketingDbCategory.items = res.data.marketingDbs
					this.marketingDbCategory.value = res.data.marketingDbs[0]
				} else {
					this.marketingDbCategory.items = []
					this.marketingDbCategory.value = null
				}
			})
		},

		/**** 캠페인 리스트 호출해서 캠페인 셀렉트박스 데이터 세팅
 @author 전현균
 */
		async campaignsTitle() {
			const variable = {}

			if (this.projectCategory.value && this.projectCategory.value.id !== 'all') {
				variable['businessId'] = String(this.projectCategory.value.id)
			}

			if (this.marketingDbCategory.value && this.marketingDbCategory.value.id !== 'all') {
				variable['marketingDBId'] = String(this.marketingDbCategory.value.id)
			}

			// 캠페인 리스트 불러오기
			await this.$store.dispatch('campaignsTitle', variable).then(async res => {
				if (res.data.campaigns.length > 0) {
					res.data.campaigns.unshift({
						id: 'all',
						title: '전체',
					})
					this.campaignCategory.items = res.data.campaigns
					this.campaignCategory.value = res.data.campaigns[0]
				} else {
					this.campaignCategory.items = []
					this.campaignCategory.value = null
				}
			})
		},

		/**** 프로젝트 셀렉트박스 변경
 @author 전현균
 */
		async projectChange() {
			this.$store.state.loading = true
			this.type = 'search'
			this.searchTag = []
			this.table.datatable.pagination.page = 1
			this.table.datatable.page = 1
			await this.marketingDbsTitle()
			await this.campaignsTitle()
			await this.getMarketingDBcustomerList()

			this.$store.state.loading = false
		},

		/**** 마케팅 DB 셀렉트박스 변경
 @author 전현균
 */
		async marketingDbChange() {
			this.$store.state.loading = true
			this.type = 'search'
			this.searchTag = []
			this.table.datatable.pagination.page = 1
			this.table.datatable.page = 1
			await this.campaignsTitle()
			await this.getMarketingDBcustomerList()

			this.$store.state.loading = false
		},

		async campaignChange() {
			this.$store.state.loading = true
			this.type = 'search'
			this.searchTag = []
			this.table.datatable.pagination.page = 1
			this.table.datatable.page = 1
			await this.getMarketingDBcustomerList()

			this.$store.state.loading = false
		},
		/**비즈니스 모델 리스트를 불러와 카테고리 적용
		@author 임호진
		*/

		async getMarketingDBcustomerList(range) {
			if (!this.projectCategory.value) {
				this.table.datatable.items = []
				this.table.datatable.total = 0
				this.alert_dialog.modalIcon = 'error'
				this.alert_dialog.title = '프로젝트 선택 에러'
				this.alert_dialog.content = '프로젝트를 선택해 주세요'
				this.alert_dialog.open = true
				return
			}

			this.$store.state.loading = true

			let variable = {}

			if (range) {
				variable['start'] = range.start
				variable['limit'] = range.limit
			} else {
				variable['start'] = (this.table.datatable.pagination.page - 1) * this.table.datatable.pagination.itemsPerPage
				variable['limit'] = this.table.datatable.pagination.itemsPerPage
			}

			// 프로젝트 id 세팅
			if (this.projectCategory.value && this.projectCategory.value.id !== 'all') {
				variable['businessId'] = [String(this.projectCategory.value.id)]
			} else {
				let new_arr = []
				for (let i = 0; i < this.projectCategory.items.length; i++) {
					if (this.projectCategory.items[i].id !== 'all') {
						new_arr.push(this.projectCategory.items[i].id)
					}
				}
				variable['businessId'] = new_arr
			}

			// 마케팅DB id 세팅
			if (this.marketingDbCategory.value && this.marketingDbCategory.value.id !== 'all') {
				variable['marketingId'] = String(this.marketingDbCategory.value.id)
			}

			// 캠페인 id 세팅
			if (this.campaignCategory.value && this.campaignCategory.value.id !== 'all') {
				variable['campaignId'] = String(this.campaignCategory.value.id)
			}

			if (this.type === 'search') {
				// 상태 세팅
				if (this.statusSel.value && this.statusSel.value !== 'all') {
					variable['processStatus'] = String(this.statusSel.value)
				}

				if (this.searchResultSel.value && this.searchResultSel.value !== 'all') {
					variable['resultStatus'] = String(this.searchResultSel.value)
				}

				// 검색 상태 세팅
				if (this.searchStatusSel.value && this.searchStatusSel.value !== 'all' && this.search.value !== '') {
					if (this.searchStatusSel.value === 'manageId') {
						variable['manageId'] = String(this.search.value)
					} else if (this.searchStatusSel.value === 'customerId') {
						variable['customerId'] = String(this.search.value)
					} else if (this.searchStatusSel.value === 'phone') {
						variable['phone'] = String(this.search.value)
					} else if (this.searchStatusSel.value === 'name') {
						variable['name'] = String(this.search.value)
					} else if (this.searchStatusSel.value === 'csnName') {
						variable['csnName'] = String(this.search.value)
					}
				}
			} else if (this.type === 'create') {
				if (!this.createStartPicker.date || !this.createEndPicker.date) {
					return false
				}

				variable['createStart'] = new Date(this.$moment(this.createStartPicker.date).format('YYYY-MM-DD 00:00:00'))
				variable['createEnd'] = new Date(this.$moment(this.createEndPicker.date).format('YYYY-MM-DD 23:59:59'))
			} else if (this.type === 'process') {
				if (!this.processStartPicker.date || !this.processEndPicker.date) {
					return
				}
				variable['processStart'] = new Date(this.$moment(this.processStartPicker.date).format('YYYY-MM-DD HH:mm:ss'))
				variable['processEnd'] = new Date(this.$moment(this.processEndPicker.date).format('YYYY-MM-DD HH:mm:ss'))
			} else if (this.type === 'tag') {
				for (let i = 0; i < this.searchTag.length; i++) {
					if (this.searchTag[i].key === 'mdb_created') {
						variable['createStart'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 00:00:00'))
						variable['createEnd'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 23:59:59'))
					} else if (this.searchTag[i].key === 'cs_processed') {
						variable['processStart'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 00:00:00'))
						variable['processEnd'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 23:59:59'))
					} else if (this.searchTag[i].key === 'resultStatus') {
						variable['resultStatus'] = this.searchTag[i].value.resultStatus
						variable['resultGrade'] = this.searchTag[i].value.resultGrade
					} else {
						variable[`${this.searchTag[i].key}`] = this.searchTag[i].value
					}
				}
			} else {
				return false
			}

			await this.$store
				.dispatch('marketingDBcustomerList', variable)
				.then(res => {
					this.$store.state.loading = false
					const response = res.data.customerDetail.response
					this.$refs.search_input.$children[0].$refs.input.blur()

					if (response.code === 1000) {
						// 성공 시에만 데이터 세팅
						let new_arr = []
						// 데이터 형식 맞추기
						for (let index = 0; index < response.data.length; index++) {
							let single_data = { ...response.data[index] }
							single_data['index'] = variable.start + index + 1
							single_data['cs_phone_original'] = single_data['cs_phone']
							single_data['cs_phone'] = single_data['cs_phone'] ? this.maskingPhoneNumber(single_data['cs_phone']) : ''
							single_data['cs_name_original'] = single_data['cs_name']
							single_data['cs_name'] = single_data['cs_name'] ? this.maskingName(single_data['cs_name']) : ''
							single_data['mdb_created'] = single_data['mdb_created']
								? this.$moment(single_data['mdb_created']).format('YYYY-MM-DD HH:mm')
								: '' // 생성일
							single_data['cs_processed'] = single_data['cs_processed']
								? this.$moment(single_data['cs_processed']).format('YYYY-MM-DD HH:mm')
								: null // 추출일
							single_data['cs_status_text'] = this.convertStatus(single_data['cs_status'], single_data['cs_like']).status // 상태
							single_data['cs_status_text_original'] = single_data['cs_status_text'] === '처리' ? 'processed' : 'unprocessed'
							single_data['cs_result'] = this.convertStatus(single_data['cs_status'], single_data['cs_like']).like // 결과
							single_data['cs_result_original'] = { resultStatus: single_data['cs_status'], resultGrade: single_data['cs_like'] } // 결과
							single_data['cn_info'] = single_data['cn_info'] ? single_data['cn_info'] + ' / ' + single_data['cn_name'] : '-'

							new_arr.push(single_data)

							// 빈값인 것들 '-' 로 처리
							for (const [key, value] of Object.entries(single_data)) {
								if (!value) single_data[key] = '-'
							}
						}
						this.table.datatable.items = new_arr
						this.table.datatable.total = response.total
					} else {
						this.table.datatable.items = []
						this.table.datatable.total = 0
					}
				})
				.catch(err => {
					if (err) {
						this.alert_dialog.open = true
						this.alert_dialog.title = '서버오류'
						this.alert_dialog.content = '서버오류가 발생했습니다.1'
					}
				})
		},
		/**캠페인데이터에서 서칭 필터를 걸때는 강제로 페이지를 1로 이동시킨후 작업해줌
	@author 노의진
	*/
		async searchKeyword() {
			this.table.datatable.page = 1
			this.table.datatable.pagination.page = 1
			await this.getMarketingDBcustomerList()
		},
		/**검색란 엔터키 핸들러
		@author 임호진
		*/
		handleEnterKey() {
			this.first = false
			this.searchType = 'text'
			// this.search_project = this.search_project_input
			this.getMarketingDBcustomerList()
		},
		// 페이지네이션 처리
		async pagination(item) {
			if (!this.table.datatable.pagination) {
				this.table.datatable['pagination'] = item
				this.table.datatable.options = item
			}
			if (item.itemsPerPage === -1) item.itemsPerPage = this.table.datatable.total
			if (item.page > this.table.datatable.pagination.page) {
				// 다음 페이지
				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				if (this.type === 'single_tag') {
					await this.getSingleCustomerDetail(range)
				} else {
					await this.getMarketingDBcustomerList(range)
				}
			} else if (item.itemsPerPage !== this.table.datatable.pagination.itemsPerPage) {
				// 한페이지에 보여줄 아이템 개수 변경

				let range = {
					start: 0,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: 1,
				}
				if (this.type === 'single_tag') {
					await this.getSingleCustomerDetail(range)
				} else {
					await this.getMarketingDBcustomerList(range)
				}
			} else if (item.page < this.table.datatable.pagination.page) {
				// 이전 페이지

				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				if (this.type === 'single_tag') {
					await this.getSingleCustomerDetail(range)
				} else {
					await this.getMarketingDBcustomerList(range)
				}
			}
			this.table.datatable['pagination'] = JSON.parse(JSON.stringify(item))
		},

		// 엑셀파일 다운로드
		async getExcelData() {
			this.$store.state.loading = true
			console.log(this.type)

			let variable = {}

			if (this.type === 'single_tag') {
				for (let i = 0; i < this.searchTag.length; i++) {
					if (this.searchTag[i].key === 'mdb_created') {
						variable['createStart'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 00:00:00'))
						variable['createEnd'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 23:59:59'))
					} else if (this.searchTag[i].key === 'cs_processed') {
						variable['processStart'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 00:00:00'))
						variable['processEnd'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 23:59:59'))
					} else if (this.searchTag[i].key === 'resultStatus') {
						variable['resultStatus'] = this.searchTag[i].value.resultStatus
						variable['resultGrade'] = this.searchTag[i].value.resultGrade
					} else {
						variable[`${this.searchTag[i].key}`] = this.searchTag[i].value
					}
				}
				this.$store.state.loading = true
				let excel_data = []
				await this.$store.dispatch('marketingDBcustomerSingle', variable).then(res => {
					this.$store.state.loading = false
					const response = res.data.singleCustomerDetail.response
					this.$refs.search_input.$children[0].$refs.input.blur()
					if (response.code === 1000) {
						// 성공 시에만 데이터 세팅
						let new_arr = []
						// 데이터 형식 맞추기

						for (let index = 0; index < response.data.length; index++) {
							let single_data = { ...response.data[index] }
							single_data['index'] = index + 1
							single_data['cs_phone'] = this.$gf.convertPhoneReg(single_data['cs_phone'])
							single_data['mdb_created'] = single_data['mdb_created']
								? this.$moment(single_data['mdb_created']).format('YYYY-MM-DD HH:mm')
								: '' // 생성일
							single_data['cs_processed'] = single_data['cs_processed']
								? this.$moment(single_data['cs_processed']).format('YYYY-MM-DD HH:mm')
								: null // 추출일
							single_data['cs_status_text'] = this.convertStatus(single_data['cs_status'], single_data['cs_like']).status // 상태
							single_data['cs_result'] = this.convertStatus(single_data['cs_status'], single_data['cs_like']).like // 결과
							single_data['cn_info'] = single_data['cn_info'] ? single_data['cn_info'] + ' / ' + single_data['cn_name'] : '-'
							new_arr.push(single_data)
							// 빈값인 것들 '-' 로 처리
							for (const [key, value] of Object.entries(single_data)) {
								if (!value) single_data[key] = '-'
							}
						}
						excel_data = new_arr
					} else {
						excel_data = []
					}
				})
				this.$store.state.loading = false
				this.excelArr = []
				return excel_data
			} else {
				// 프로젝트 id 세팅
				if (this.projectCategory.value && this.projectCategory.value.id !== 'all') {
					variable['businessId'] = [String(this.projectCategory.value.id)]
				} else {
					return []
					// let new_arr = []
					// for (let i = 0; i < this.projectCategory.items.length; i++) {
					// 	if (this.projectCategory.items[i].id !== 'all') {
					// 		new_arr.push(this.projectCategory.items[i].id)
					// 	}
					// }
					// variable['businessId'] = new_arr
				}

				// 마케팅DB id 세팅
				if (this.marketingDbCategory.value && this.marketingDbCategory.value.id !== 'all') {
					variable['marketingId'] = String(this.marketingDbCategory.value.id)
				}

				// 캠페인 id 세팅
				if (this.campaignCategory.value && this.campaignCategory.value.id !== 'all') {
					variable['campaignId'] = String(this.campaignCategory.value.id)
				}

				if (this.type === 'search') {
					// 상태 세팅
					if (this.statusSel.value && this.statusSel.value !== 'all') {
						variable['processStatus'] = String(this.statusSel.value)
					}

					// 검색 상태 세팅
					if (this.searchStatusSel.value && this.searchStatusSel.value !== 'all' && this.search.value !== '') {
						if (this.searchStatusSel.value === 'manageId') {
							variable['manageId'] = String(this.search.value)
						} else if (this.searchStatusSel.value === 'customerId') {
							variable['customerId'] = String(this.search.value)
						} else if (this.searchStatusSel.value === 'phone') {
							variable['phone'] = String(this.search.value)
						} else if (this.searchStatusSel.value === 'name') {
							variable['name'] = String(this.search.value)
						}
					}
				} else if (this.type === 'create') {
					if (!this.createStartPicker.date || !this.createEndPicker.date) {
						return false
					}

					variable['createStart'] = new Date(this.$moment(this.createStartPicker.date).format('YYYY-MM-DD 00:00:00'))
					variable['createEnd'] = new Date(this.$moment(this.createEndPicker.date).format('YYYY-MM-DD 23:59:59'))
				} else if (this.type === 'process') {
					if (!this.processStartPicker.date || !this.processEndPicker.date) {
						return
					}
					variable['processStart'] = new Date(this.$moment(this.processStartPicker.date).format('YYYY-MM-DD HH:mm:ss'))
					variable['processEnd'] = new Date(this.$moment(this.processEndPicker.date).format('YYYY-MM-DD HH:mm:ss'))
				} else if (this.type === 'tag') {
					for (let i = 0; i < this.searchTag.length; i++) {
						if (this.searchTag[i].key === 'mdb_created') {
							variable['createStart'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 00:00:00'))
							variable['createEnd'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 23:59:59'))
						} else if (this.searchTag[i].key === 'cs_processed') {
							variable['processStart'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 00:00:00'))
							variable['processEnd'] = new Date(this.$moment(this.searchTag[i].value).format('YYYY-MM-DD 23:59:59'))
						} else if (this.searchTag[i].key === 'resultStatus') {
							variable['resultStatus'] = this.searchTag[i].value.resultStatus
							variable['resultGrade'] = this.searchTag[i].value.resultGrade
						} else {
							variable[`${this.searchTag[i].key}`] = this.searchTag[i].value
						}
					}
				} else {
					return false
				}

				let excel_data = []

				await this.$store.dispatch('marketingDBcustomerList', variable).then(res => {
					this.$store.state.loading = false
					const response = res.data.customerDetail.response
					this.$refs.search_input.$children[0].$refs.input.blur()

					if (response.code === 1000) {
						// 성공 시에만 데이터 세팅
						let new_arr = []
						// 데이터 형식 맞추기
						for (let index = 0; index < response.data.length; index++) {
							let single_data = { ...response.data[index] }
							single_data['index'] = index + 1
							single_data['cs_phone'] = this.$gf.convertPhoneReg(single_data['cs_phone'])
							single_data['mdb_created'] = single_data['mdb_created']
								? this.$moment(single_data['mdb_created']).format('YYYY-MM-DD HH:mm')
								: '' // 생성일
							single_data['cs_processed'] = single_data['cs_processed']
								? this.$moment(single_data['cs_processed']).format('YYYY-MM-DD HH:mm')
								: null // 추출일
							single_data['cs_status_text'] = this.convertStatus(single_data['cs_status'], single_data['cs_like']).status // 상태
							single_data['cs_result'] = this.convertStatus(single_data['cs_status'], single_data['cs_like']).like // 결과
							single_data['cn_info'] = single_data['cn_info'] ? single_data['cn_info'] + ' / ' + single_data['cn_name'] : '-'

							new_arr.push(single_data)

							// 빈값인 것들 '-' 로 처리
							for (const [key, value] of Object.entries(single_data)) {
								if (!value) single_data[key] = '-'
							}
						}
						excel_data = new_arr
					} else {
						excel_data = []
					}
				})

				this.$store.state.loading = false
				this.excelArr = []
				return excel_data
			}
		},

		// 셀렉트 박스 선택된 값 테이블 적용
		async setdate() {
			let today = new Date()
			let before = new Date(today.setDate(today.getDate() - 7))
			let after = new Date(today.setDate(today.getDate() + 7))
			this.createStartPicker.date = this.$moment(before).format('YYYY-MM-DD')
			this.createEndPicker.date = this.$moment(after).format('YYYY-MM-DD')
			this.processStartPicker.date = this.$moment(before).format('YYYY-MM-DD')
			this.processEndPicker.date = this.$moment(after).format('YYYY-MM-DD')
		},
		termCustomer(val) {
			let start = this.$moment(this.createStartPicker.date).format('YYMMDD')
			let startDate = new Date(this.createStartPicker.date)
			let end = new Date(startDate.setDate(startDate.getDate() + 240))
			let endDate = this.$moment(end).format('YYMMDD')

			val = this.$moment(val).format('YYMMDD') < endDate && this.$moment(val).format('YYMMDD') >= start
			return val
		},

		/**** 전화번호 마스킹 
 @author 전현균 
 @returns 010-**12-**34
 */
		maskingPhoneNumber(phoneNumber) {
			const values = phoneNumber.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`).split('-')
			if (values.length > 1) {
				values[1] = '*'.repeat(values[1].length - 2) + values[1][values[1].length - 2] + values[1][values[1].length - 1]
			}
			if (values.length > 2) {
				values[2] = '*'.repeat(values[2].length - 2) + values[2][values[1].length - 2] + values[2][values[1].length - 1]
			}
			return values.join('-')
		},

		/**** 이름 마스킹 
 @author 전현균 
 @returns 홍*동
 */
		maskingName(strName) {
			if (strName.length > 2) {
				var originName = strName.split('')
				originName.forEach((name, i) => {
					if (i === 0 || i === originName.length - 1) return
					originName[i] = '*'
				})
				var joinName = originName.join()
				return joinName.replace(/,/g, '')
			} else {
				var pattern = /.$/ // 정규식
				return strName.replace(pattern, '*')
			}
		},

		convertStatus(status, like) {
			let data_form = {
				status: '',
				like: '',
			}
			/*
				meetingReserve - 방문예약
				meetingNoShow - 미방문
				meetingDone - 상담완료
				contractExpect - 계약가망
				contractTemp - 가계약
			*/

			switch (status) {
				case 'success':
					data_form.status = '처리'
					data_form.like = `통화성공[${like}]`
					break
				case 'reserve':
					data_form.status = '처리'
					data_form.like = `통화예약`
					break
				case 'absence':
					data_form.status = '처리'
					data_form.like = `보류`
					break
				case 'reject':
					data_form.status = '처리'
					data_form.like = `거부`
					break
				case 'meetingReserve':
					data_form.status = '처리'
					data_form.like = `방문예약`
					break
				case 'meetingNoShow':
					data_form.status = '처리'
					data_form.like = `미방문`
					break

				case 'meetingDone':
					data_form.status = '처리'
					data_form.like = `상담완료[${like}]`
					break

				case 'contractExpect':
					data_form.status = '처리'
					data_form.like = `계약가망`
					break

				case 'contractTemp':
					data_form.status = '처리'
					data_form.like = `가계약`
					break

				case 'contractConfirm':
					data_form.status = '처리'
					data_form.like = `계약확인`
					break

				default:
					data_form.status = '미처리'
					data_form.like = '-'
					break
			}
			return data_form
		},
	},
}
</script>
<style lang="scss" scoped>
.wrapper {
	margin: 0px !important;
}
</style>
<style lang="scss">
.surveyChoice {
	font-size: 18px;
	font-weight: bold;
	margin-right: 10px;
}

.surveyTitle {
	font-size: 18px;
	font-weight: bold;
	margin-top: 20px;
}

.filterFlex {
	padding: 20px 20px 58px 0px;
}

.filterBox {
	background: white;
	height: 100%;
	border: 2px solid #e1e1e1;
	border-radius: 5px;
}

.filterHead {
	margin: 0px !important;
	padding: 14px;
	border-bottom: 1.5px solid #e1e1e1;
}

.filterLayout {
	padding: 14.8px;
	// border-bottom: 1.5px solid #e1e1e1;`
}

.checkboxLinebreak {
	line-break: anywhere;
}

.qaLists-dialog {
	opacity: 0;
	width: 100%;
	background-color: white !important;
}

//검색 박스
.maketingDB_search_box_type {
	width: 100% !important;
	max-width: 260px !important;
	height: 26px !important;
	// margin-right: 10px !important;
	padding: 0 5px !important;
	font-size: 13px;
	font-weight: bold;

	.v-btn__content {
		color: #fff;
	}

	div {
		div {
			.v-input__slot {
				min-height: 26px !important;
				height: 26px;
				padding: 0 10px !important;
			}
		}
	}
}

.maketingDB_search_select_type {
	min-height: 26px !important;
	height: 26px !important;
	width: 16.5% !important;
	max-width: 185px !important;
	.v-input {
		font-size: 12px !important;
	}

	div {
		div {
			div {
				div {
					.v-input__append-inner {
						margin-top: 1px !important;
					}
				}
			}
		}
	}
}

.customer-circumstance-text {
	font-size: 12px;
	font-weight: bold;
	width: 50px !important;
	max-width: 50px !important;
	// width: auto;
	color: #204037;
	text-align: center;
}
.customer-circumstance-text_1 {
	font-size: 12px;
	font-weight: bold;
	width: 50px !important;
	max-width: 50px !important;
	// width: auto;
	color: #204037;
	text-align: center;
}
.customer-circumstance-text_2 {
	font-size: 12px;
	font-weight: bold;
	width: 50px !important;
	max-width: 50px !important;
	// width: auto;
	color: #204037;
	text-align: center;
}

.customer-management-btn {
	box-shadow: none;
	border: 1px solid #c5c3d5;
	width: 6.29%;
	height: 26px !important;
	background-color: #f3f3ff !important;

	.v-btn__content {
		color: #323153;
		font-size: 13px;
	}
}
.maketingDB_search_date_1 {
	width: 10.5% !important;
	max-width: 120px !important;
	.defalut-date-picker-setting {
		width: unset !important;
	}
}
.maketingdb_search_date_2 {
	width: 9.5% !important;
	max-width: 120px !important;
	.defalut-date-picker-setting {
		width: unset !important;
	}
}
.maketingDB_search_date_1_editTalk {
	max-width: 100px !important;
	.theme--light.v-input {
		width: 7.14% !important;
	}
}
.maketingdb_search_date_2_editTalk {
	max-width: 100px !important;
	.theme--light.v-input {
		width: 7.14% !important;
	}
}
// 기간 별 버튼
.search_select_1 {
	min-height: 26px !important;
	height: 26px !important;
	// width: 3.5% !important;
	max-width: 150px !important;
	div {
		div {
			div {
				div {
					.v-input__append-inner {
						margin-top: 1px !important;
					}
				}
			}
		}
	}
}
//검색 버튼
.search_btn_1 {
	width: 5% !important;
	max-width: 65px !important;
	height: 26px !important;
	margin-right: 10px !important;
	padding: 0 10px !important;
	font-size: 13px;
	font-weight: bold;
	.v-btn__content {
		color: #fff;
	}
}

.search_sub_wrap {
	margin-top: 16px !important;
	min-height: 21px !important;
	max-height: 21px !important;
	font-weight: normal;
	.sub_text_title {
		display: flex;
		> div {
			display: flex;
			border-bottom: 1px solid #333;
			padding: 2px !important;
		}
	}
}
.customer-circumstance-sub-text {
	font-size: 12px !important;
	color: #333 !important;
	font-weight: normal;
	display: flex;
	align-items: center;
	justify-content: center;
}
.sub-text_chip_close {
	cursor: pointer;
	margin-left: 2px !important;
	background-color: rgb(255, 255, 255, 0.4);
	padding-top: 1px !important;
	color: #333 !important;
	font-size: 12px !important;
	width: 12px !important;
	min-height: 0 !important;
}
.header_search_box {
	border-top: 1px solid #ffd999;
	background: #fffaf2;
	border-bottom: 1px solid #ffd999;
}
.header_search_1 {
	height: 38px;
	// max-width: 90%;
}

.search_range_btn_1 {
	// width: 8.5% !important;
	height: 26px !important;
	margin-left: 18px !important;
	padding: 0 10px !important;
	font-size: 13px;
	font-weight: bold;
	.v-btn__content {
		color: #fff;
	}
}
.etc_date {
	width: 1% !important;
	max-width: 10px !important;
}
.search_box_1 {
	width: 10%;
}
</style>
